import { ChainId } from '~enums'

export function getChainId(): ChainId {
  return parseInt(process.env.REACT_APP_CHAIN_ID, 10)
}
